class VideoControler {

    //
    //  VideoControler
    //  Eigen wrapper rondom video element
    //

    constructor( _videoelement ) {
      this.version = 1.0;
      this.videoelement = _videoelement;
      this.loaded = false;
      this.pause_time = 0;

      this.videoelement.addEventListener( 'loadeddata', this.ready.bind(this) );
      this.videoelement.addEventListener( 'timeupdate', this.update.bind(this) );
    }

    set( _start_time, _pause_time ) {
      this.pause_time = _pause_time;
      this.videoelement.currentTime = _start_time;
      if( this.videoelement.src ) this.videoelement.play();
    }

    ready() {
      this.loaded = true; 
      // Possible use autoplay on videoelement
    }

    update() {
      if( false === this.loaded ) return;
      var seconds = this.videoelement.currentTime; // Math.floor(this.videoelement.currentTime);
      if( seconds >= this.pause_time ) this.videoelement.pause();
    }

}